import React, { useEffect, useState } from 'react';
import ProductPart from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/ProductPart';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from "react-redux";
import get from 'lodash/get';

const useStyles = makeStyles(
    (theme) => ({
  root: {
    position: "relative",
    display: "inline-block"
  },
  rootActive: {
    position: "relative",
    display: "inline-block",
      '& span' : {
      color: `${theme.custom.palette.veryDark} !important`,
    },
  },
  visitedIcon: {
    position: 'absolute',
    left: 25,
    bottom: 35,
    zIndex: 1,
    color: 'white',
    background: '#9bc944',
    borderRadius: 50,
    stroke: "white",
    strokeWidth: 2,
    fontSize: "1.1rem",
    padding: "0.22rem",
  },
}));

export const CustomProductPart = (props) => {
  const classes = useStyles();

  const [visited, setVisited] = useState('');

  // set the visited state when the option list is closed
  const { selectedOption, optionclassification } = props;
  const selected = selectedOption?.identifier === optionclassification.identifier;
  const optionsListVisible = useSelector(state => get(state, 'ui.visibilityMap.optionlist'));
  useEffect(() => {
    if (!visited && selected && optionsListVisible) {
      setVisited('active');
    } else if (visited === 'active' && !optionsListVisible) {
      setVisited('visited');
    }
  }, [selected, visited, optionsListVisible]);

  // reset visible state when start here is shown (= configuration is reset)
  const startHereVisible = useSelector(state => get(state, 'ui.visibilityMap.startHere'));
  useEffect(() => {
    if (startHereVisible) {
      setVisited('');
    }
  }, [startHereVisible]);

  return (
    <div className={selected && optionsListVisible ? classes.rootActive : classes.root}>
      <ProductPart {...props} />
      {visited === 'visited' && <CheckIcon className={classes.visitedIcon}/>}
    </div>
  );
}

export default CustomProductPart;
